// Backported from OLD sg and refactored so it works with the old and the new navigation. (for the feature flag)

export function stickyBar(el: HTMLElement): void {
  const navigation = document.querySelector<HTMLElement>('.phxsg-navigation');
  const oldNav = document.querySelector<HTMLElement>('.header');
  const oldNavTopbar = document.querySelector<HTMLElement>('.topbar');

  const useOldNav = oldNav && oldNavTopbar;

  if (!useOldNav && !navigation) {
    return;
  }

  function setTop(top: string): void {
    if (el.style.top !== top) {
      el.style.top = top;
    }
  }

  function calculateTop(): void {
    if (useOldNav && oldNav && oldNavTopbar) {
      const navbarHeight = oldNav.offsetHeight - 1;
      const topbarHeight = oldNavTopbar.offsetHeight - 1;
      const { top: offsetTop } = el.getBoundingClientRect();

      if (!oldNav.classList.contains('is-hidden') && offsetTop >= 0) {
        setTop(`${navbarHeight}px`);
      } else {
        setTop(`${topbarHeight}px`);
      }
    } else if (navigation) {
      const navigationRect = navigation.getBoundingClientRect();
      const navigationHeight = navigationRect.height;
      const navigationTop = navigationRect.top;

      if (navigationTop >= 0) {
        setTop(`${navigationHeight}px`);
      } else {
        const visibleHeight = Math.max(0, navigationHeight + navigationTop);
        setTop(`${visibleHeight}px`);
      }
    }
  }

  window.addEventListener('scroll', calculateTop, { passive: true });
  window.addEventListener('resize', calculateTop, { passive: true });

  calculateTop();
}
